export default {
  status: 'Status',
  acceptQueueCalls: 'Accept call queue calls',
  callQueueDisabledReason:
    'This setting is managed by your company administrator.',
  callQueueManagement: 'Manage queues',
} as const;
